var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"indigo",attrs:{"loading":_vm.loading_btn,"dark":"","icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.toggleTestLanguage()}}},[_c('v-icon',[_vm._v("mdi-translate")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }